import { IMailboxFilter } from '@/api/types/response.types'

/* Mirrors Domain.Entities.Types.MailboxFilterTypes */
export enum EMailboxFilterTypes {
  Email = 0,
  Domain = 1,
  Folder = 2,
  SentTo = 3,
}

/* Mirrors Domain.Entities.Types.MailboxFilterActions */
export enum EMailboxFilterActions {
  Allow = 0,
  Block = 1,
}

/* Mirrors how the webhook applies filters (Domain.Utilities.MailboxFilterMatcher) */
export default new class MailboxFilterAssistant {
  /* e.g. "from @example.com", "in Support" or "to billing@example.com" */
  public describe(filter: IMailboxFilter): string {
    switch (filter.mailboxFilterType) {
      case EMailboxFilterTypes.Domain:
        return `from @${filter.value}`
      case EMailboxFilterTypes.Folder:
        return `in ${filter.name}`
      case EMailboxFilterTypes.SentTo:
        return `to ${filter.value}`
      default:
        return `from ${filter.value}`
    }
  }

  /* Which emails a mailbox accepts, e.g. "Emails to billing@example.com, except from @spam.com" */
  public summarize(filters: IMailboxFilter[]): string {
    const allowed = filters.filter(
      f => f.mailboxFilterAction === EMailboxFilterActions.Allow,
    )
    const blocked = filters.filter(
      f => f.mailboxFilterAction === EMailboxFilterActions.Block,
    )
    const accepted = allowed.length
      ? `Emails ${this.list(allowed)}`
      : 'All emails'

    return blocked.length
      ? `${accepted}, except ${this.list(blocked)}`
      : accepted
  }

  /* With no allow list, a mailbox accepts every email it doesn't block */
  public isCatchAll(filters: IMailboxFilter[]): boolean {
    return filters.length === 0
  }

  private list(filters: IMailboxFilter[]): string {
    const shown = filters
      .slice(0, 2)
      .map(f => this.describe(f))
      .join(' or ')

    return filters.length > 2 ? `${shown}, +${filters.length - 2} more` : shown
  }
}()
